export default "__VITE_ASSET__FtP2O8wJ__"